// extracted by mini-css-extract-plugin
module.exports = {"heading":"AuthViewHeadline_heading__1zGC3","text":"AuthViewHeadline_text__1mRkC","mail":"AuthViewHeadline_mail__2f3ZS","divider":"AuthViewHeadline_divider__1D5GG"};